import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import AppContent from "./components/AppContent";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "./utils/stripe";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>} persistor={persistor}>
        <ProtectedRoute>
          <Elements stripe={stripePromise}>
            <AppContent />
          </Elements>
        </ProtectedRoute>
      </PersistGate>
    </Provider>
  );
}

export default App;
